export const MOBILE_APP_USER_AGENT = "Read AI Mobile";

export const APP_VIEW_SEARCH_PARAM = "appView";

export const MOBILE_APP_PARAMS = {
  MOBILE_APP_VIEW: "mobileApp",
  RETURN_URL: "return_url",
};
